import AwsExports from '@/.config/aws-exports'
import Amplify from 'aws-amplify'
import Auth from '@aws-amplify/auth'
import moment from 'moment'
import LocalDataUtil from '@/util/LocalDataUtil.js'
import Swal from 'sweetalert2'

import axios from 'axios'
import * as url from './url'
import qs from 'qs'

Amplify.configure(AwsExports)
let client = axios.create()

client.interceptors.response.use(
  async response => {
    if (response.config.url.indexOf('https://api.ccsapp.jp/api') !== -1 || response.config.url.indexOf('https://qa1-api.ccsapp.jp/api') !== -1) {
      // Spring
      if (response.data.status !== '0') {
        throw response
      }
      return response
    } else if (response.config.url.indexOf('https://l6zmwgh6j9.execute-api.ap-northeast-1.amazonaws.com/prod') !== -1 || response.config.url.indexOf('https://mrb2uijegc.execute-api.ap-northeast-1.amazonaws.com/dev2') !== -1) {
      // Lambda
      if (response.status !== 200) {
        throw response
      }
      return response
    } else if (response.config.url.indexOf('https://p001.c-c-system.com') !== -1 || response.config.url.indexOf('https://ccsp-staging.c-c-system.com') !== -1) {
      // CCS
      if (response.data.result === '0') {
        throw response
      } else if (response.data.result === '-1') {
        alert('タイムアウトになりました。もう一度ログインしなおしてください。')
        localStorage.clear()
        location.href = '/signin'
        throw response
      }
      return response
    } else {
      return response
    }
  },
  async error => {
    if (error.config.url.indexOf('https://api.ccsapp.jp/api') !== -1 || error.config.url.indexOf('https://qa1-api.ccsapp.jp/api') !== -1) {
      // Spring
      if (error.response.status === 401) {
        alert('タイムアウトになりました。もう一度ログインしなおしてください。')
        localStorage.clear()
        location.href = '/signin'
      }
      throw error
    } else if (error.config.url.indexOf('https://l6zmwgh6j9.execute-api.ap-northeast-1.amazonaws.com/prod') !== -1 || error.config.url.indexOf('https://mrb2uijegc.execute-api.ap-northeast-1.amazonaws.com/dev2') !== -1) {
      // Lambda
      if (error.status !== 200) {
        throw error
      }
      throw error
    } else if (error.config.url.indexOf('https://p001.c-c-system.com') !== -1 || error.config.url.indexOf('https://ccsp-staging.c-c-system.com') !== -1) {
      // CCS
      if (error.data.result === '-1') {
        Swal.fire({
          text: error.data.error
        }).then(() => {
          localStorage.clear()
          location.href = '/signin'
        })
        throw error
      }
      throw error
    } else {
      throw error.response
    }
  }
)

export default class ApiClient {
  static async checkMaintenance (data) {
    let params = new URLSearchParams()
    params.append('data', JSON.stringify(data))
    const URL = (await url.SPR_URL.getUrl('sprFetchMaintenance'))
    return client({
      method: 'post',
      url: URL,
      data: params
    })
  }
  // nurseryCodeはCCSで各園のAPIをリクエストするときに使う
  static async createMethod (type, api, data, nurseryCode = null, serverId = null) {
    // メンテナンスチェック
    // try {
    //   const isMaintenance = (await this.checkMaintenance({type: 'admin'})).data.data.is_maintenance
    //   if (isMaintenance) throw new Error('maintenance')
    // } catch (error) {
    //   if (error.message === 'maintenance') {
    //     Swal.fire({
    //       title: 'メンテナンス',
    //       html: '現在メンテナンス中です<br>時間をおいてもう一度お試しください',
    //       type: 'warning'
    //     }).then(() => {
    //       location.href = '/signin'
    //     })
    //     throw error
    //   }
    // }
    // メンテナンス中でなければ通常通りリクエスト処理を行う
    if (type === 'SPR') {
      // spring api request
      let params = new URLSearchParams()
      params.append('data', JSON.stringify(data))
      const URL = (await url.SPR_URL.getUrl(api))
      return client({
        method: 'post',
        url: URL,
        data: params
      })
    } else if (type === 'LAM') {
      // LAMBDA api request
      const URL = (await url.LAM_URL.getUrl(api))
      return client({
        method: 'post',
        url: URL,
        data: JSON.stringify(data)
      })
    } else if (type === 'COG') {
      // Cognito request
      if (api === 'checkSessionExpired') {
        const accessToken = LocalDataUtil.getJwtToken()
        let EXPIRE
        if (accessToken) {
          const base64Url = accessToken.split('.')[1]
          const base64 = base64Url.replace('-', '+').replace('_', '/')
          EXPIRE = JSON.parse(window.atob(base64)).exp
        }
        if (accessToken && EXPIRE > moment().unix()) {
          return false
        } else {
          try {
            let tmp = (await Auth.signOut())
            if (!tmp) {
              localStorage.clear()
              return true
            }
          } catch (error) { }
        }
      } else if (api === 'changePassword') {
        return Auth.changePassword(data.user, data.oldPassword, data.newPassword)
      } else {
        return Auth[api](data)
      }
    } else if (type === 'APPSYNC') {
      try {
        return (await url.APPSYNC_URL[api](data))
      } catch (error) {
        throw error.errors
      }
    } else if (type === 'CCS') {
      // CCS api request
      const URL = (await url.CCS_URL.getUrl(api, nurseryCode, serverId))
      return client({
        method: 'post',
        url: URL,
        data: qs.stringify(data),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/util.js